async function setup () {
  const res = await fetch('static/services-config.json')
  return res.json()
}

export default {
  services: {},
  setup: async function () {
    if (Object.keys(this.services).length === 0) {
      this.services = await setup()
    }
  }
}
